const ShowValidationError = ({ error }: { error: string }) => {
  return (<div className="text-red-600 mt-1">{error}</div>);
};

export default ShowValidationError;